import { useState } from "react"
import { faCalendarCheck, faMug } from "@fortawesome/pro-solid-svg-icons"

import { UserType } from "../../../modules/login/loginTypes"
import { ButtonConfigType } from "../filters/orderTypeFilter/StandardOrderTypeFilter"

// Order type for creating orders (resource booking and meeting service only)
export enum CreateOrderType {
    RESOURCE_BOOKING = "RESOURCE_BOOKING",
    MEETING_SERVICE = "MEETING_SERVICE",
}

// Configuration for creating orders buttons
export const createOrderButtonConfig: ButtonConfigType<CreateOrderType>[] = [
    {
        value: CreateOrderType.RESOURCE_BOOKING,
        icon: faCalendarCheck,
        className: "buttonPurple",
    },
    {
        value: CreateOrderType.MEETING_SERVICE,
        icon: faMug,
        className: "buttonTeal",
    },
]

export const MEETING_SERVICE_SUPERUSER_TYPES: ReadonlyArray<UserType> = [
    UserType.MERCHANT,
    UserType.SUPPLIER,
    UserType.SUPPORT,
]

export function useOrderCreation(initialValue: CreateOrderType = CreateOrderType.RESOURCE_BOOKING) {
    const [orderType, setOrderType] = useState<CreateOrderType>(initialValue)

    return {
        orderType,
        setOrderType,
    }
}
